module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered city-addition"
  }, [_c('draggable', {
    attrs: {
      "options": {
        disabled: _vm.editableCity !== null
      }
    },
    model: {
      value: (_vm.eventCityObject),
      callback: function($$v) {
        _vm.eventCityObject = $$v
      },
      expression: "eventCityObject"
    }
  }, _vm._l((_vm.eventCityObject), function(place) {
    return _c('span', {
      staticClass: "city-wrapper",
      on: {
        "click": function($event) {
          return _vm.handleGetEventCity(place.id)
        }
      }
    }, [(_vm.editableCity !== place.id) ? _c('router-link', {
      key: place.id,
      staticClass: "city-title",
      class: _vm.$route.params.id === place.id || !_vm.$route.params.id && _vm.eventCities[0].id === place.id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'Events',
          params: {
            id: place.id
          }
        }
      }
    }, [_vm._v(_vm._s(place.name) + "\n          ")]) : _c('span', {
      staticClass: "edit-city-wrapper"
    }, [_c('a', {
      staticClass: "delete hide-edit-city",
      on: {
        "click": function($event) {
          return _vm.toggleEditCity(place.id)
        }
      }
    }), _vm._v(" "), _c('b-input', {
      staticClass: "edit-city-input",
      model: {
        value: (_vm.newCityName),
        callback: function($$v) {
          _vm.newCityName = $$v
        },
        expression: "newCityName"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "apply-icon is-medium",
      attrs: {
        "src": "/static/img/icons/apply.svg"
      },
      on: {
        "click": _vm.handleUpdateEventCities
      }
    })], 1), _vm._v(" "), _c('img', {
      staticClass: "edit-icon",
      attrs: {
        "src": "/static/img/icons/edit.svg"
      },
      on: {
        "click": function($event) {
          return _vm.toggleEditCity(place.id)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.cityAdditionVisible) ? _c('span', {
    staticClass: "button-wrapper city-addition-wrapper",
    on: {
      "click": _vm.toggleAddition
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить город\n      ")]) : _vm._e(), _vm._v(" "), (_vm.cityAdditionVisible) ? _c('b-field', {
    staticClass: "city-addition-input"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название города"
    },
    model: {
      value: (_vm.cityName),
      callback: function($$v) {
        _vm.cityName = $$v
      },
      expression: "cityName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-primary button",
    on: {
      "click": _vm.handleNewEventCity
    }
  }, [_vm._v("Добавить")]), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-warning button",
    on: {
      "click": _vm.toggleAddition
    }
  }, [_vm._v("Отмена")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.eventCity) ? _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddEvent
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить мероприятие\n      ")])]), _vm._v(" "), (_vm.eventCity.events) ? _c('div', {
    staticClass: "events columns is-multiline"
  }, _vm._l((_vm.eventCity.events), function(event) {
    return _c('router-link', {
      key: event.id,
      staticClass: "event-wrapper column is-half",
      attrs: {
        "to": {
          name: 'Event',
          params: {
            id: event.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "event centered"
    }, [(event.eventParticipants.length) ? _c('span', {
      ref: "event.id",
      refInFor: true,
      staticClass: "link",
      attrs: {
        "id": event.id
      },
      on: {
        "click": _vm.showParticipants
      }
    }, [_vm._v("\n            Посмотреть " + _vm._s(event.eventParticipants.length) + " зарегистровавшихся\n          ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("filterDate")(event.date)) + " "), _c('br')]), _vm._v(" "), _c('span', {
      staticClass: "event-title"
    }, [_vm._v(_vm._s(event.title) + " "), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(event.description) + " "), _c('br')])])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column delete-service",
    on: {
      "click": function($event) {
        return _vm.deleteEventCity(_vm.eventCity.id)
      }
    }
  }, [_c('span', [_vm._v("Удалить город и все мероприятия")])])])]) : _vm._e(), _vm._v(" "), (_vm.event) ? _c('el-dialog', {
    staticClass: "event-dialog",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "event-participants"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.event.title) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.event.date) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "event-participants-count"
  }, [_vm._v("\n        " + _vm._s(_vm.event.eventParticipants.length) + "\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "participants-table"
  }, _vm._l((_vm.event.eventParticipants), function(participant) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(participant.surname) + " "), _c('br'), _vm._v(" " + _vm._s(participant.name) + " " + _vm._s(participant.patronymic))]), _vm._v(" "), _c('td', {
      staticClass: "commpany-name"
    }, [_vm._v(" " + _vm._s(participant.companyName))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.phone))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.email))])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190fb5db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EventsList.vue
// module id = 901
// module chunks = 0